import React from 'react'
import {
  StyledContent,
  TitleBackground,
  BodyTitle,
  ButtonIconRound,
  ContentBody,
  HeaderTitle,
  BackgroundGradient,
  HeaderSubtitle,
  HeaderBox,
  TitleBox
} from './Content.styles'
import type { ContentProps } from './interface'
import { useHistory } from 'react-router-dom'
import {
  LIVROS_HOME_ROOT_PATH,
  ATUALIDADES_HOME_ROOT_PATH,
  INGLES_HOME_ROOT_PATH,
  SENTIR_HOME_ROOT_PATH,
  SENTIR_DIARIO_HOME_ROOT_PATH,
  LER_HOME_ROOT_PATH,
  LER_REVISTAS_E_JORNAIS_HOME_ROOT_PATH,
  LER_NOTICIAS_HOME_ROOT_PATH,
  COMUNICAR_HOME_ROOT_PATH
} from 'routes/paths'
import { useTranslation } from 'i18n'

const Content: React.FC<ContentProps> = ({
  children,
  noPaddingForMobileScreen,
  noPaddingForAnyScreen,
  className,
  noWidth,
  title,
  subtitle: Subtitle,
  dontShowDesktopTitle,
  pathGoBack,
  showAlerts = true
}) => {
  const { t } = useTranslation()
  const history = useHistory()
  const modularHomeSubDomains = [
    LIVROS_HOME_ROOT_PATH,
    ATUALIDADES_HOME_ROOT_PATH,
    INGLES_HOME_ROOT_PATH,
    SENTIR_HOME_ROOT_PATH,
    SENTIR_DIARIO_HOME_ROOT_PATH,
    LER_HOME_ROOT_PATH,
    LER_REVISTAS_E_JORNAIS_HOME_ROOT_PATH,
    LER_NOTICIAS_HOME_ROOT_PATH,
    COMUNICAR_HOME_ROOT_PATH
  ]

  const currentPath = history?.location.pathname

  const isHomePageActive = modularHomeSubDomains.some(subDomain => {
    return currentPath === subDomain
  })

  const renderStyledContent = () => {
    return (
      <>
        {isHomePageActive && <BackgroundGradient />}
        <StyledContent
          data-testid="content"
          className={`modular-content ${className}`}
          noPaddingForMobileScreen={noPaddingForMobileScreen}
          noPaddingForAnyScreen={noPaddingForAnyScreen}
          noWidth={noWidth}
        >
          {children}
        </StyledContent>
      </>
    )
  }

  const renderContentBody = () => {
    return (
      <ContentBody data-testid="content" className="modular-content">
        <BodyTitle size={1}>{title}</BodyTitle>
        {children}
      </ContentBody>
    )
  }
  const renderBody = () => {
    if (title && !dontShowDesktopTitle) return renderContentBody()

    return renderStyledContent()
  }

  return (
    <>
      {title && !dontShowDesktopTitle && (
        <TitleBackground>
          <ContentBody data-testid="content">
            <HeaderBox>
              <TitleBox>
                <ButtonIconRound
                  iconName="arrow-left"
                  theme={{ type: 'ghost', size: 'xLarge' }}
                  onClick={() => history.goBack()}
                />
                <HeaderTitle size={1}>{t(title)}</HeaderTitle>
              </TitleBox>
              {Subtitle &&
                (typeof Subtitle === 'string' ? (
                  <HeaderSubtitle>{t(Subtitle)}</HeaderSubtitle>
                ) : (
                  <Subtitle />
                ))}
            </HeaderBox>
          </ContentBody>
        </TitleBackground>
      )}
      {renderBody()}
    </>
  )
}

export default Content
